<template>
  <el-dialog
    title="修改手机号码"
    :visible.sync="visible"
    width="500px"
    :close-on-click-modal="false"
    append-to-body
    :before-close="closeDialog"
  >
    <el-form ref="form" :model="form" :rules="rules" label-width="100px" size="small">
      <el-form-item label="密码" prop="password">
        <el-input v-model.trim="form.password" type="password" placeholder="请输入密码" show-password />
      </el-form-item>
      <el-form-item label="新手机号码" prop="phone">
        <el-input v-model.trim="form.phone" placeholder="请输入新手机号码" maxlength="11" />
      </el-form-item>
      <el-form-item label="验证码" prop="code">
        <div class="flex-row">
          <el-input v-model.trim="form.code" placeholder="请输入验证码" style="flex: 1" maxlength="6" />
          <el-button
            :disabled="!!timer || loading"
            style="margin-left: 10px;width: 120px"
            type="primary"
            @click="getCode"
          >
            {{ timer ? `${countdown}秒后重试` : '获取验证码' }}
          </el-button>
        </div>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button size="small" @click="closeDialog">取 消</el-button>
      <el-button size="small" type="primary" :loading="loading" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { sendCode, modifyPhone } from '@/api/system/user'
import { useInitUtil } from '@/utils/init'

export default {
  name: 'ModifyPhone',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    // 验证手机号码
    const validatePhone = (rule, value, callback) => {
      if (!this.$util.validate.isMobile(value)) {
        callback(new Error('请输入正确的手机号码'))
      } else {
        callback()
      }
    }
    return {
      loading: false,
      timer: null,
      countdown: 60,

      form: {
        password: '',
        phone: '',
        code: ''
      },
      rules: {
        password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入新手机号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' },
          { len: 6, message: '验证码长度为6位', trigger: 'blur' }
        ]
      }
    }
  },
  beforeDestroy() {
    this.clearTimer()
  },
  methods: {
    /**
     * 获取验证码
     */
    async getCode() {
      this.$refs.form.validateField('phone', async valid => {
        if (valid) return
        try {
          await sendCode({ phone: this.form.phone })
          this.startCountdown()
        } catch (error) {
          console.error(error)
        }
      })
    },

    /**
     * 开始倒计时
     */
    startCountdown() {
      this.countdown = 60
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown--
        } else {
          this.clearTimer()
        }
      }, 1000)
    },

    /**
     * 清除定时器
     */
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    },

    /**
     * 提交表单
     */
    submit() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          this.loading = true
          try {
            await modifyPhone({
              passWord: this.form.password,
              newPhone: this.form.phone,
              smsCode: this.form.code
            })
            this.$message.success('手机号码修改成功')
            this.closeDialog()
            this.loading = false
          } catch (error) {
            this.loading = false
          }
        }
      })
    },

    /**
     * 关闭对话框
     */
    closeDialog() {
      this.clearTimer()
      this.$emit('update:visible', false)
      setTimeout(() => {
        useInitUtil.init(this.form)
      }, 200)
      setTimeout(() => {
        this.$refs.form?.clearValidate()
      }, 400)
    }
  }
}
</script>
